import React, { useState }            from 'react';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import PropTypes                      from 'prop-types';
import styled                         from 'styled-components';

const ElementArea = styled.div`
  background   : white;
  color        : #111111;
  border-radius: 0.5em;
  line-height  : 1.5;

  &:not(:last-of-type) {
    margin-bottom: 1.5em;
  }

  ${props => props.style_ext ? props.style_ext.header : ''}
`;

const ItemTitle = styled.div`
  padding        : 0 1.5em;
  display        : flex;
  justify-content: space-between;
  align-items    : center;
  cursor         : pointer;

  > svg {
    flex-shrink: 0;
  }
`;

const Text = styled.p`
  display  : inline-block;
  flex-grow: 1;
`;

const Explandable = styled.div`
  padding      : 1.7em 2.4em;
  font-size    : 0.9em;
  border-radius: 0 0 0.3em 0.3em;
  background   : #f0f0f0;
  ${props => props.style_ext ? props.style_ext.content : ''}
`;

const ExplandableItem = ({ label, children, styles}) => {
  const [open, setOpen] = useState(false);

  return (
    <ElementArea style_ext={styles}>
      <ItemTitle onClick={() => setOpen(!open)}>
        <Text>{label}</Text>
        {open ? <MdExpandLess size="3em" /> : <MdExpandMore size="3em" />}
      </ItemTitle>
      {open && <Explandable style_ext={styles}>{children}</Explandable>}
    </ElementArea>
  );
};

ExplandableItem.propTypes = {
  label   : PropTypes.node.isRequired,
  children: PropTypes.any,
  styles  : PropTypes.object
};

export default ExplandableItem;
